'use strict';

var MODULE_NAME = 'tael.module.common';
var ngModule = angular.module(MODULE_NAME, ['ngRoute', 'ngAnimate', 'ngSanitize', 'ui.sortable', "oc.lazyLoad", 'blueimp.fileupload' // file upload
]);
ngModule.config(function () {
  $.ajaxSetup({
    traditional: true
  });
  numeral.language('fr', {
    delimiters: {
      thousands: ' ',
      decimal: ','
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function ordinal(number) {
      return number === 1 ? 'er' : 'ème';
    },
    currency: {
      symbol: '€'
    }
  });
  numeral.language('fr');
  moment.locale("fr");
});

// Warning : do NOT factorize this : webpack will not be able to parse parametrized context paths.
function requireAllInContext(context) {
  context.keys().forEach(context);
}
requireAllInContext(require.context("./ng", true, /\.(js|ts|less|css)$/));
requireAllInContext(require.context("./css", true, /\.(js|ts|less|css)$/));
module.exports = MODULE_NAME;


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/common-module.js
// module id = 7
// module chunks = 13